module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/ja-2.33ce1971.png";